import {WINDOW_DELIMITER_WIDTH} from '../constants';

const
  NAME               = 'animatedUnderline',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

class AnimatedUnderline {
  constructor(element$) {
    this._element$ = element$;
    this._underline$ = element$.find('.voc-underline');
    this._scrollable$ = element$.find('.voc-scrollable');

    if (_elementExists(element$.find('.voc-active')) && _elementExists(this._underline$)) {
      this._activeEl$ = element$.find('.voc-active');

      this._elementAttr = this._element$.data().vocAnimatedUnderline;

      //NOTE: Scroll to active element if it's to the right of centre
      if (_isNotMobile() || (this._elementAttr == 'allDevices')) {
        var windowHalfWidth = $(window).width() / 2;
        var actElHalfWidth  = this._activeEl$.width() / 2;
        var maxActElLeftPos = windowHalfWidth - actElHalfWidth;
        var actElLeftPos    = this._activeEl$.offset().left;

        if(actElLeftPos > maxActElLeftPos) {
          this._scrollable$.scrollLeft(actElLeftPos - windowHalfWidth + actElHalfWidth);

          if(_elementExists(this._element$.find('.dropdown'))) {
            for(var i=0; i < this._element$.find('.dropdown').length; i++) {
              var ddElement$   = this._element$.find('.dropdown')[i];
              var ddElLeftPos  = $(ddElement$).offset().left;
              var ddMenu$      = $(ddElement$).find('.dropdown-menu');

              ddMenu$.css('left', (ddElLeftPos + 12) + 'px');
            }
          }
        }
      }

      // NOTE: Assign width and left properties to the underline element
      this._activeElWidth = this._activeEl$.width();
      this._activeElLeft  = this._activeEl$.position().left + parseInt(this._activeEl$.css('marginLeft'));
      this.positioningUnderline();


      if (_isNotMobile() || (this._elementAttr == 'allDevices')) {
        element$ .on('mouseover', 'a', (e) => this.onMouseOver(e));
        element$ .on('mouseleave',     (e) => this.onMouseOut(e));
        $('body').on('click',          (e) => this.onClick(e));
      }

      $(window).on('resize', (e) => this.onResize(e));
    }
  }

  positioningUnderline(width, left) {
    this._underline$.css({
      width: `${width ? width : this._activeElWidth}px`,
      left:  `${left  ? left  : this._activeElLeft}px`
    });
  }

  onMouseOver(event) {
    if (!$('.dropdown.open').length) {
      let target, elWidth, elLeft;

      target  = event.target;

      if (target.nodeName === 'A') {
        let dropdownParent = $(target).closest('.dropdown');

        elWidth = target.offsetWidth;
        elLeft  = target.offsetLeft;

        if (dropdownParent.length) {
          elWidth = dropdownParent.find('.dropdown-toggle').width();
          elLeft  = dropdownParent.find('.dropdown-toggle').position().left;
        }

        this.positioningUnderline(elWidth, elLeft);
      }
    }
  }

  onMouseOut(/*event*/) {
    if (!$('.dropdown.open').length) {
      this.positioningUnderline();
    }
  }

  onClick(event) {
    if (!$(event.target).closest(this._element$).length) {
      this.positioningUnderline();
    }
  }

  onResize(/*event*/) {
    if (this._element$.find('.voc-active')) {
      //NOTE: Scroll to active element if it's to the right of centre
      if (_isNotMobile() || (this._elementAttr == 'allDevices')) {
        var windowHalfWidth = $(window).width() / 2;
        var actElHalfWidth  = this._activeEl$.width() / 2;
        var maxActElLeftPos = windowHalfWidth - actElHalfWidth;
        var actElLeftPos    = this._activeEl$.offset().left;

        if(actElLeftPos > maxActElLeftPos) {
          this._scrollable$.scrollLeft(actElLeftPos - windowHalfWidth + actElHalfWidth);

          if(_elementExists(this._element$.find('.dropdown'))) {
            for(var i=0; i < this._element$.find('.dropdown').length; i++) {
              var ddElement$   = this._element$.find('.dropdown')[i];
              var ddElLeftPos  = $(ddElement$).offset().left;
              var ddMenu$      = $(ddElement$).find('.dropdown-menu');

              ddMenu$.css('left', (ddElLeftPos + 12) + 'px');
            }
          }
        }
      }

      this._activeElWidth = this._activeEl$.width();
      this._activeElLeft  = this._activeEl$.position().left + parseInt(this._activeEl$.css('marginLeft'));
      this.positioningUnderline();
    }

    if (_elementExists(this._underline$) && _isNotMobile()) {
      this._element$.on('mouseover', 'a', this.onMouseOver.bind(this));
      this._element$.on('mouseleave', this.onMouseOut.bind(this));

    } else {
      this._element$.off('mouseover');
      this._element$.off('mouseleave');
    }
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface() {
    return this.each(function() {
      new AnimatedUnderline($(this));
    });
  }
}

$.fn[NAME]             = AnimatedUnderline._jQueryInterface;
$.fn[NAME].Constructor = AnimatedUnderline;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return AnimatedUnderline._jQueryInterface;
};

export default AnimatedUnderline;

/* Private  */
function _elementExists(element$) {
  return element$.length;
}

function _isNotMobile() {
  return window.innerWidth >= WINDOW_DELIMITER_WIDTH;
}



// WEBPACK FOOTER //
// ./src/plugins/animated-underline.js